import useMute from 'hooks/useMute'
import { BellOff } from 'lucide-react'
import useActionGuard from 'hooks/useActionGuard'
import { User, Relationship } from '@wellesley/openapi'

type UseMuteUnmuteActionProps = {
  user: User
  isHidden: boolean
  relationship: Relationship
  onMuteSuccess?: () => void
}

const useMuteUnmuteAction = ({
  user,
  isHidden,
  relationship,
  onMuteSuccess,
}: UseMuteUnmuteActionProps) => {
  const { isDisabled, guardedAction } = useActionGuard()
  const { renderMuteDialog, isMuted, mute, unmute } = useMute({
    user,
    relationship,
    onMute: onMuteSuccess,
  })

  const muteUnmuteAction = {
    icon: <BellOff size={20} color="var(--gray-900)" />,
    name: isMuted ? 'Unmute' : 'Mute',
    isHidden,
    handler: guardedAction(isMuted ? unmute : mute),
    disabled: isDisabled,
  }

  return [muteUnmuteAction, renderMuteDialog] as const
}

export default useMuteUnmuteAction
